import * as React from 'react';

import Hamburger20 from './Hamburger20';

export const hamburger20 = () => <Hamburger20 />;

export default {
    title: 'Icon/Fill/Hamburger20',
    component: Hamburger20,
    parameters: {
        notes: "`import Hamburger20 from 'box-ui-elements/es/icon/fill/Hamburger20';`",
    },
};
